import { openNotification } from "./notifications"

const copyToClipboard = (content, messages, showNotification = true, placement) => {
  const { success, error } = messages || {
    success: 'Copied to the clipboard',
    error: 'Sorry, that content could not be copied.'
  }

  if (!content) {
    if (showNotification) openNotification('Nothing to copy', "warn", undefined, placement)
    return
  }

  if (!navigator.clipboard) {
    const textArea = document.createElement("textarea")
    textArea.value = content
    textArea.style.position = "fixed"
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
      if (showNotification) openNotification(success, "success", undefined, placement)
      return true
    } catch (err) {
      if (showNotification) openNotification(error, "danger", undefined, placement)
    }

    document.body.removeChild(textArea)
    return false
  }

  navigator.clipboard.writeText(content).then(() => {
    if (showNotification) openNotification(success, "success", undefined, placement)
    return true
  }).catch((error) => {
    if (showNotification) openNotification(error, "danger", undefined, placement)
  })

  return false
}

export default copyToClipboard